import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { ContainerGradeRepairCodeSearchComponent } from '../../components/container-grade-repair-code/container-grade-repair-code-search/container-grade-repair-code-search.component';
import { ContainerGradeRepairCodeGridComponent } from '../../components/container-grade-repair-code/container-grade-repair-code-grid/container-grade-repair-code-grid.component';
import { ContainerGradeRepairCodeFiltersComponent } from '../../components/container-grade-repair-code/container-grade-repair-code-filters/container-grade-repair-code-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NavigationStart, Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ContainerGradeRepairCodeFilterForm } from '../../form-model/container-grade-repair-code-filter.form.model';
import { ContainerGradeRepairCodeSearchTextForm } from '../../form-model/container-grade-repair-code-search-text.form.model';
import { ContainerGradeRepairCodeService } from '../../services/container-grade-repair-code.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-container-grade-repair-code-list',
  templateUrl: './container-grade-repair-code.component.html',
  styleUrls: ['./container-grade-repair-code.component.scss'],
  imports: [
    ContainerGradeRepairCodeSearchComponent,
    RouterLink,
    RouterModule,
    ContainerGradeRepairCodeGridComponent,
    ContainerGradeRepairCodeFiltersComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContainerGradeRepairCodeListComponent implements OnInit, OnDestroy {
  filterFormGroup = this.formBuilder.group({
    filterForm: this.formBuilder.group<ContainerGradeRepairCodeFilterForm>({} as ContainerGradeRepairCodeFilterForm),
    searchTextForm: this.formBuilder.group<ContainerGradeRepairCodeSearchTextForm>({} as ContainerGradeRepairCodeSearchTextForm),
  });

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly service: ContainerGradeRepairCodeService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!event.url.startsWith('/master-data/container-grade-repair-code')) {
          this.service.setFilterFormValue(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
